import {UserFieldsFragment} from '../../generated';

export const isUser = (fragment?: UserFieldsFragment | null) =>
  fragment?.__typename === 'User';
